import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { versionActionsComponent } from './versionActions.component';

@NgModule({
    declarations: [versionActionsComponent],
    imports: [TranslateModule, CommonModule, RouterModule],
    exports: [versionActionsComponent]

})

export class VersionActionsModule { }

